export class Regex {
    static PT_EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static PT_WEB_PATTERN = "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+.[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$";
    static PT_WEB_PATTERN_ALT = "^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$";
    static PT_PHONE_PATTERN = [/[0-9]/, '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
    static PT_POSTAL_ZONE_PATTERN = [/\d/, /\d/, /\d/, /\d/, /\d/];
    static PT_MERSIS_NO_PATTERN = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

    static PT_CREDIT_CARD_PATTERN = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
    static PT_CREDIT_CARD_CVV_PATTERN = [/\d/, /\d/, /\d/];

    static DATE_PATTERN = [/\d/, /\d/, , '.', /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];

    static ENGLISH_CHARS = /^[a-zA-Z]+$/;

    static DOMAIN_ONLY = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;
    static CONFIRM_CODE = /^[0-9]{1,6}$/;

}